module.exports = __webpack_public_path__ + "img/tasks.0b557c48.svg";